const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 4,
    backgroundColor: '#f9f9f9',
  },
  gridContainer: {
    maxWidth: 800,
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    p: 3,
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    mb: 2,
  },
  card: {
    borderRadius: 8,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    p: 2,
  },
  loadingSpinner: {
    color: '#007bff',
  },
  subtitle: {
    marginBottom: '8px',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    color: '#333',
  },
};

export default styles;
